<template>
  <div id="header" class="sticky top-0 w-full z-40">
    <Menu :class="{ 'shadow-bottom': headerStore.scrollPosition > 0 && headerStore.selectedMenu.navbarList == undefined }" />
    <NavBar :class="{ 'shadow-bottom': headerStore.scrollPosition > 0 && headerStore.selectedMenu.navbarList != undefined }" />
  </div>
</template>
<script setup lang="ts">
import Menu from "./Menu.vue";
import NavBar from "./NavBar.vue";

import { computed, onMounted, ref, toRefs } from "vue";
import { useHeaderStore } from "@/stores/header";

const headerStore = useHeaderStore();
</script>
